// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__f_bK2","list":"PatternAutocomplete_list__2Jd_Z"};